import axios from 'axios';
const domain = 'https://api.cnmsrgblab.com/';
export const getData = async (path) => {
    return await axios
        .get(domain + path + '/')
        .then(res => { return res.data })
        .catch(error => console.log(error));
}

export const getAdminData = async (path, body) => {
    return await axios
        .post(domain + path + '/', body)
        .then(res => {
            if (res.status === 200) {
                return res.data;
            }
            else {
                return undefined;
            }
        })
        .catch(error => console.log(error));
}

export const postData = async (path, body) => {
    return await axios
        .post(domain + path + '/', body)
        .then(res => { return res.data })
        .catch(error => console.log(error));
}

export const postImage = async (body) => {
    return await axios
        .post(domain + 'uploadImage/', body, { headers: { 'content-type': 'multipart/form-data' } })
        .then(res => {
            if (res.status === 200 || res.status === 201) {
                return res.data;
            }
            else {
                return undefined;
            }
        })
        .catch(error => console.log(error));
}

export const postFile = async (body) => {
    return await axios
        .post(domain + 'uploadFile/', body, { headers: { 'content-type': 'multipart/form-data' } })
        .then(res => {
            if (res.status === 200 || res.status === 201) {
                return res.data;
            }
            else {
                return undefined;
            }
        })
        .catch(error => console.log(error));
}